import styled, { css } from "styled-components";
import { borderRadius, boxShadow, color, onHover, variant } from "@m/alchemy-theme";
export const getRotatedSize = (size) => Math.hypot(size, size) / 2;
export const offset = ({ offset }) => `${offset}px`;
export const negativeCenter = ({ size }) => `-${getRotatedSize(size) / 2}px`;
export const size = ({ size }) => `${getRotatedSize(size)}px`;
const caretLocation = variant("location", {
    topLeft: css `
    left: ${offset};
    top: ${negativeCenter};
  `,
    topCenter: css `
    top: ${negativeCenter};
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  `,
    topRight: css `
    top: ${negativeCenter};
    right: ${offset};
  `,
    rightTop: css `
    top: ${offset};
    right: ${negativeCenter};
  `,
    rightCenter: css `
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    right: ${negativeCenter};
  `,
    rightBottom: css `
    bottom: ${offset};
    right: ${negativeCenter};
  `,
    bottomCenter: css `
    bottom: ${negativeCenter};
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  `,
    bottomLeft: css `
    bottom: ${negativeCenter};
    left: ${offset};
  `,
    bottomRight: css `
    bottom: ${negativeCenter};
    right: ${offset};
  `,
    leftCenter: css `
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    left: ${negativeCenter};
  `,
    leftBottom: css `
    bottom: ${offset};
    left: ${negativeCenter};
  `,
    leftTop: css `
    top: ${offset};
    left: ${negativeCenter};
  `
});
export const Caret = styled.div `
  background-color: ${color("container")};
  transform-origin: 50% 50%;
  display: block;
  height: ${size};
  position: absolute;
  transform: rotate(45deg);
  width: ${size};
  ${caretLocation};
  ${({ border }) => border
    ? css `
          border: ${border};
        `
    : css `
          border: 1px solid ${color("line")};
        `};
`;
export const BoxWrapper = styled.div `
  background-color: ${color("container")};
  border-radius: ${(props) => borderRadius(props.borderRadius)};
  height: 100%;
  left: 0;
  opacity: ${(props) => props.backgroundOpacity};
  position: absolute;
  top: 0;
  width: 100%;

  ${({ border }) => border
    ? css `
          border: ${border};
        `
    : css `
          border: 1px solid ${color("line")};
        `};

  ${({ depth }) => depth &&
    css `
      box-shadow: ${boxShadow(depth)};

      ${Caret} {
        box-shadow: ${boxShadow(depth)};
      }
    `};
`;
export const Background = styled.div `
  background-color: ${color("container")};
  border-radius: ${(props) => borderRadius(props.borderRadius)};
  overflow: hidden; /* this forces children to obey the wrapper border-radius */
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
export const Content = styled.div `
  position: relative;
  margin: 1px;
`;
export const Box = styled.div `
  position: relative;
  color: ${color("typeBody")};
  background-color: ${color("container")};
  border-radius: ${(props) => borderRadius(props.borderRadius)};
  opacity: ${(props) => props.backgroundOpacity};

  ${({ hoverDepth }) => hoverDepth !== undefined &&
    onHover(css `
        box-shadow: ${boxShadow(hoverDepth)};

        ${Caret} {
          box-shadow: ${boxShadow(hoverDepth)};
        }
      `, { includeKeyboardFocus: false })};
`;
